
import {Observable ,Subscription as ISubscription } from 'rxjs';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { FileServiceHttp } from '../../core/services/file.servicehttp';
import { of as observableOf} from 'rxjs/observable/of'

 @Injectable()
 export class TestKitDetailResolveFile implements Resolve<any> {
  constructor(private fileService: FileServiceHttp) {}

  resolve(router: ActivatedRouteSnapshot) {
    console.log('test-kit-detail-resolveFile');
    const fileId = router.params['id'];
    if (fileId !== 'new') {
      return this.fileService.getFile(fileId);
    } else {
      observableOf(null);
    }
  }
}
